import { Portfolio } from "@/@types/global";

type CreatePortfolio = Omit<
  Portfolio,
  "ivr" | "entity" | "operation_type" | "type_default_management"
> & {
  ivr: number | null;
  entity: number;
  operation_type: number;
  type_management: number;
  type_typification_call: number;
};

export type FormState = Partial<CreatePortfolio>;

export enum OperationType {
  ClientAttention = 1,
  Marketing = 2,
  Sells = 3,
  Collection = 4,
}
